export default {
      id: "funnel-clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#funnel-clock-usage",
      toString: function () {
        return this.url;
      }
    }